function SchoolList({ schools = [], selectedId, onSelect }) {
  const handleClick = (school) => {
    if (onSelect) {
      onSelect(school);
    }
  };

  return (
    <ul className="school-list">
      {schools.length === 0 && <li className="empty">لا توجد مدارس حالياً.</li>}

      {schools.map((school) => {
        const schoolId = school?._id || school?.id || school?.name;
        const isActive = selectedId && schoolId === selectedId;
        return (
          <li
            key={schoolId}
            className={isActive ? 'active' : ''}
            onClick={() => handleClick(school)}
          >
            <div className="school-name">
              {school?.schoolName || school?.name || 'بدون اسم'}
            </div>
            {school?.city && <div className="school-meta">المدينة: {school.city}</div>}
          </li>
        );
      })}
    </ul>
  );
}

export default SchoolList;

